import React from "react"
import classNames from "classnames"

import { getCharPortrait } from "@/utils/assets"

import styles from "./index.module.less"

export interface IIconProps {
    className?: string
    style?: React.CSSProperties
}

export const IconCaster: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="caster"
        />
    )
}

export const IconTank: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="tank"
        />
    )
}

export const IconWarrior: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="warrior"
        />
    )
}

export const IconMedic: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="medic"
        />
    )
}

export const IconSniper: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="sniper"
        />
    )
}

export const IconSpecial: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="special"
        />
    )
}

export const IconSupport: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="support"
        />
    )
}

export const IconPioneer: React.FC<IIconProps> = ({ className, style }) => {
    return (
        <div
            className={classNames(styles.iconProfession, className)}
            style={style}
            data-value="pioneer"
        />
    )
}

interface IProps {
    className?: string
    style?: React.CSSProperties
    profession: string
    operators: string[]
}

export const professionMap = {
    PIONEER: {
        label: "VANGUARD",
        icon: <IconPioneer className={styles.icon} />,
    },
    WARRIOR: {
        label: "GUARD",
        icon: <IconWarrior className={styles.icon} />,
    },
    TANK: {
        label: "DEFENDER",
        icon: <IconTank className={styles.icon} />,
    },
    SNIPER: {
        label: "SNIPER",
        icon: <IconSniper className={styles.icon} />,
    },
    CASTER: {
        label: "CASTER",
        icon: <IconCaster className={styles.icon} />,
    },
    MEDIC: {
        label: "MEDIC",
        icon: <IconMedic className={styles.icon} />,
    },
    SUPPORT: {
        label: "SUPPORTER",
        icon: <IconSupport className={styles.icon} />,
    },
    SPECIAL: {
        label: "SPECIALIST",
        icon: <IconSpecial className={styles.icon} />,
    },
}

const Top3Operators: React.FC<IProps> = (props) => {
    const { className, style, profession, operators = [] } = props
    return (
        <div
            className={classNames(styles.top3Operators, className)}
            style={style}
        >
            <div className={styles.operators}>
                {operators.map((operator, index) => (
                    <div key={index} className={styles.operator}>
                        <img
                            className={styles.portrait}
                            src={getCharPortrait(operator)}
                            loading="lazy"
                        />
                    </div>
                ))}
            </div>
            <div className={styles.profession}>
                <div className={styles.label}>
                    <div>{professionMap[profession].label}</div>
                </div>
                {professionMap[profession].icon}
            </div>
        </div>
    )
}

export default Top3Operators
